export const ACTUALIZAR_PROVEEDORES = "ACTUALIZAR_PROVEEDORES";
export const ACTUALIZAR_PROVEEDORES_DB = "ACTUALIZAR_PROVEEDORES_DB";
export const CARGANDO_PROV = "CARGANDO_PROV";
export const ERROR_PROV = "ERROR_PROV";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";